import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const BlurImage = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-position: center;
  background-size: cover;
  filter: blur(10px);
  opacity: 0.8;
  background-color: ${COLORS.line};
`;

export default BlurImage;
